import React, { useState, useEffect } from "react";
import { Box, TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button} from "@mui/material";
import {useSelector} from "react-redux"
import KhmWikiDialog from "./KhmWikiDialog"
import CustomPagination from "../../component/common/CustomPagination";

export interface KmWikiType {
  idx: number;
  site_name: string;

  title_km: string;
  text_km: string;
  
  use_yn: string;

  title_ko: string;
  text_ko: string;

  isp1_yn: string;
  isp1_user: string;
  isp1_date: string;

}

const initailData: KmWikiType = {
  idx: -1,
  site_name: "",
  title_km: "",
  text_km: "",
  
  title_ko: "",
  text_ko: "",
  
  use_yn: "",
  isp1_yn: "",
  isp1_user: "",
  isp1_date: "",
};

interface pageInfoType {
  current_page: number;
  total_pages: number;
  total_count: number;
}

const KhmWikiListPage = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  // const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const [c_page, setC_page] = useState("")

  let manager_role = auth.user.roles.some((obj:any) => ['KHM_ISP'].includes(obj.role));

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'KHM').map((info:any) => info.user_id)[0];   
  
  const [data, setData] = useState<KmWikiType>(initailData);

  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );
  
  const updateAfter = () => {
    // setData(initailData);
    props.kmWikiWorkList(props.work_yn);
  }


  useEffect(() => {
    if(props.workList.datas != undefined && props.workList.datas.length > 0){
      setData(props.workList.datas[0])
    }
    else{
      setData(initailData)
    }

    if(props.workList.pagination != undefined){
      setPagination(props.workList.pagination)
      setC_page(props.workList.pagination.current_page)
    }
   
    
  },[props])

  return (
    <Box>
      {/* Task 단위 화면 */}
      <Box display="flex" justifyContent="center" >
        <KhmWikiDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />
        <Box sx={{padding:"4px 8px 8px 8px", width:"310px"}}>
          <Box display="flex">
            <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} /></Box>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>Khmer Wiki</Box>
          </Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
          <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
            <Table size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>구분</Box></TableCell>
                  {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
              {(props.workList.datas != undefined && props.workList.datas.length > 0) ? props.workList.datas.map((row:any, index:number) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(data != undefined && row.idx === data.idx ? "#dbdbef": "#fff")}}
                  onClick={()=> {setData(row);}}
                >
                  <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                        border: (row.isp1_yn === "N" ? "2px solid red" : (row.isp1_yn === "0" ? "2px solid #498ad5" : (row.isp1_yn === "Y" ? "2px solid #27cc2f" : (row.isp1_yn === "R" ? "2px solid #ef891f" :"#bbb")))), color:"#000" }}>
                      {(row.isp1_yn === "Y" ? "적합" : (row.isp1_yn === "N" ? "부적합" : (row.isp1_yn === "None" ? "미작업":"미작업")))}
                    </Box>
                  </TableCell>
                </TableRow>
                )):<TableRow><TableCell colSpan={2} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{marginTop:"12px"}}>
            {pagination !== undefined ? (
                <>
                <CustomPagination pagination={pagination} goPage={props.goPage} />
                <Box display="flex">
                <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                  sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                  InputProps={{
                    style: {width: "60px", height:"23px", fontSize:"12px"},
                    inputProps: { 
                      spellCheck: "false" // spellcheck를 false로 설정
                    },
                  }}
                  />
                  <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>props.setPage(c_page)}>
                    이동
                  </Button>
                </Box>
                </>
            ) : ""}
          </Box>
        </Box>
        
        
      </Box>
    </Box>


  );
};

export default KhmWikiListPage;
